import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody, formatGraphqlParams } from '@/utils'

export default {
    fetch(id, name = "products.name", type = "ASC") {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getOrderProduct (
                        order_id: ${Number(id)},
                        orderBy: ["${name}", "${type}"]
                    ) {
                        id,
                        order_id,
                        product_id,
                        quantity,
                        discount_price,
                        product {
                            id,
                            name,
                            price,
                            discount_price,
                            amount,
                            description,
                            category,
                            image,
                            brand,
                            bar_code,
                            is_medication,
                            active_principle,
                            need_prescription,
                            integration_id,
                            deleted_at,
                            erp_id
                        },
                        order {
                            id,
                            chat_ticket_id,
                            purchase_value,
                            status_id,
                            is_finished_at,
                            is_pre_order,
                            erp_id,
                            is_delivery,
                            address,
                            payment_id,
                            is_canceled,
                            payment_data,
                            turned_order_at,
                            customer_knowledge_content
                        }
                    }
                }
            `
        })
    },
    updateOrderProduct(id, data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        const params = formatGraphqlParams({
            'order_id': id,
            'products': [...data]
        });

        return axios.post('', formatGraphqlBody (
            'mutation',
            'updateOrderProduct',
            null,
            params
        ))
    },
    deleteOrderProduct(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteOrderProduct (
                        id: ${id}
                    )
                }
            `
        })
    }
}
